import { FC } from 'react';

import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';
import { ResultSearchType } from '@savgroup-front-common/core/molecules/SearchWithDimmer/SearchWithDimmer.types';
import { Badge } from '@savgroup-front-common/primitive/ui/badge';
import { Button } from '@savgroup-front-common/primitive/ui/button';
import { RESULT_TYPE } from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

import { AppBarSearchResultRow } from '../AppBarSearchResultRow/AppBarSearchResultRow';

import messages from './messages';

interface AppBarSearchResultSectionProps {
  section: SearchResultList<ResultSearchType>;
  isSectionLoading: boolean;
  onShowMore: (resultType: RESULT_TYPE) => void;
  onSelectResult: () => void;
}

export const AppBarSearchResultSection: FC<AppBarSearchResultSectionProps> = ({
  section,
  isSectionLoading,
  onShowMore,
  onSelectResult,
}) => {
  const remainingCount = section.hitCount - (section.hits?.length ?? 0);
  const hasMore = !!section.type && remainingCount > 0;

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2 px-2">
        <p className="text-xs font-semibold stext-base-default">
          {safeFormattedIntlString(section.title)}
        </p>
        <Badge variant="subtle" shape="square">
          {section.hitCount}
        </Badge>
      </div>

      <div className="flex flex-col">
        {(section.hits ?? []).map((hit) => (
          <AppBarSearchResultRow
            key={hit.searchId}
            icon={section.icon}
            type={section.type}
            hit={hit}
            onSelect={onSelectResult}
          />
        ))}
      </div>

      {hasMore && (
        <Button
          variant="link"
          size="sm"
          className="h-auto w-fit px-2 text-xs"
          disabled={isSectionLoading}
          onClick={() => onShowMore(section.type as RESULT_TYPE)}
        >
          {safeFormattedIntlString(messages.showMore, {
            value: remainingCount,
          })}
        </Button>
      )}
    </div>
  );
};
